import { render } from "./componentEditAjax.vue?vue&type=template&id=967da764"
import script from "./componentEditAjax.vue?vue&type=script&lang=js"
export * from "./componentEditAjax.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__